import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";

import { feedbackApi, type FeedbackEntry } from "../api/resources";
import { EnhancedTable } from "../components/EnhancedTable";
import { PageHeader } from "../components";

const PAGE_SIZE = 30;

export function FeedbackPage() {
  const [page, setPage] = useState(1);

  const list = useQuery({
    queryKey: ["feedback", page],
    queryFn: () => feedbackApi.list({ page, pageSize: PAGE_SIZE }),
  });

  return (
    <div>
      <PageHeader
        title="用户反馈"
        description="来自 H5 / 小程序的用户反馈，按提交时间倒序排列。"
        stats={[{ label: `共 ${list.data?.total ?? 0} 条` }]}
      />

      <EnhancedTable<FeedbackEntry>
        rowKey="id"
        persistKey="feedback"
        exportFilename="feedback"
        loading={list.isLoading}
        dataSource={list.data?.items ?? []}
        emptyText="暂无反馈"
        pagination={{
          current: page,
          pageSize: PAGE_SIZE,
          total: list.data?.total ?? 0,
          onChange: (p) => setPage(p),
          showSizeChanger: false,
        }}
        columns={[
          {
            title: "内容",
            dataIndex: "content",
            render: (v: string) => (
              <span style={{ whiteSpace: "pre-wrap" }}>{v}</span>
            ),
          },
          {
            title: "联系方式",
            dataIndex: "contact",
            width: 180,
            render: (v: string | null) =>
              v ?? <span style={{ color: "#8a8580" }}>—</span>,
          },
          {
            title: "用户",
            dataIndex: "userId",
            width: 160,
            ellipsis: true,
            render: (v: string | null) =>
              v ?? <span style={{ color: "#8a8580" }}>匿名</span>,
          },
          {
            title: "时间",
            dataIndex: "createdAt",
            width: 160,
            render: (v: string) => dayjs(v).format("MM-DD HH:mm:ss"),
          },
        ]}
      />
    </div>
  );
}
